import React, { Component } from 'react'
import { GOOGLE_MAPS_API_KEY } from 'config'
import { Gmaps, Marker } from 'react-gmaps'
import mapStyles from './mapStyles.json'

const params = { v: '3.exp', key: GOOGLE_MAPS_API_KEY }

class Map extends Component {
  constructor (props) {
    super(props)

    this.onMapCreated = this.onMapCreated.bind(this)
  }

  render () {
    const { coordinates } = this.props

    return (
      <Gmaps
        ref={ref => {
          this._gmaps = ref
        }}
        height={'180px'}
        style={!this.props.useDarkTheme ? { opacity: '1' } : null}
        lat={coordinates.lat}
        lng={coordinates.lng}
        zoom={4}
        disableDefaultUI
        disableDoubleClickZoom
        draggable={false}
        scrollwheel={false}
        params={params}
        onMapCreated={this.onMapCreated}>
        <Marker
          lat={coordinates.lat}
          lng={coordinates.lng} />
      </Gmaps>
    )
  }

  onMapCreated () {
    if (this.props.useDarkTheme) {
      const gMap = this._gmaps

      // Turn on dark mode
      gMap.getMap().setOptions({
        styles: mapStyles
      })
    }
  }
}

export default Map



// WEBPACK FOOTER //
// ./components/Customers/presentational/Map.js